

import { atom , useRecoilValue, useSetRecoilState} from "recoil";


const driverAssignList = atom({key:'driverAssignList', default:{driver_list:[], so_not_shipped:[]}});




export  const SetDriverAssignList = () => useSetRecoilState(driverAssignList);
export  const GetDriverAssignList = () => useRecoilValue(driverAssignList);








